import { Flex } from '@chakra-ui/react';
import React from 'react';

const Loader = () => {
    
    return (
        
        <Flex h="500vh" align="center" justify="center">
          <body>
 
  
          <div class="e-loadholder">
  <div class="m-loader">
    <span class="e-text">MAXX STAKING</span>
    
   
  </div>
  
</div>
<div id="particleCanvas-Blue"></div>
<div id="particleCanvas-White"></div>
  
</body>
        </Flex>
    );
};

export default Loader;